import styled, { css } from 'styled-components';
import { mobile_xl } from '../../../../global/mediaQueryMixin';

const Group = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: auto;
  ${mobile_xl(css`
    height: unset;
  `)}
`;
export { Group };
